import { Record, fromJS } from 'immutable';
// @ts-expect-error ts-migrate(2305) FIXME: Module '"flux-actions"' has no exported member 'co... Remove this comment to see the full error message
import { handleActions, combineActions } from 'flux-actions';
import { TwoFactorAuthActionTypes } from '../actions/TwoFactorAuthActions';
import * as TwoFactorAuthSetupSteps from '../constants/TwoFactorAuthSetupSteps';
import { indexOfStep, getConfirmMethodStep } from '../constants/TwoFactorAuthStepOrder';
import * as TwoFactorAuthMethods from '../constants/TwoFactorAuthMethods';
import * as TwoFactorAuthPrecedenceTypes from '../constants/TwoFactorAuthPrecedenceTypes';
import TwoFactorAuthStatus from '../records/TwoFactorAuthStatus';
import TwoFactorAuthSMSErrors from '../constants/TwoFactorAuthSMSErrors';
import RequestStatusTypes from '../constants/RequestStatusTypes';
const UNINITIALIZED_INDEX = -1;
export class TwoFactorAuthState extends Record({
  persistedStatus: new TwoFactorAuthStatus(),
  requiresUserToLogin: false,
  setupStepIndex: UNINITIALIZED_INDEX,
  method: TwoFactorAuthMethods.SMS,
  precedence: TwoFactorAuthPrecedenceTypes.PRIMARY,
  qrCode: null,
  stagedSMSNumber: '',
  verificationCodeAttempt: '',
  verificationCodeFailure: false,
  printedOrSavedBackupCodes: false,
  backupModalVisible: false,
  backupCodesLoading: false,
  setupForLogin: false,
  setupForLoginAccountInfo: undefined,
  redirectUrl: undefined,
  show2FANude: false,
  setupFromNudge: false,
  isErrorSendingSMS: undefined,
  isHubSpotAppSet: false,
  hsMobileAppVersionStatus: RequestStatusTypes.UNINITIALIZED
}) {}
const initialState = new TwoFactorAuthState();
export default handleActions({
  [TwoFactorAuthActionTypes.SETUP_2FA_FROM_NUDGE](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.merge({
      redirectUrl: action.payload.redirectUrl,
      show2FANude: true,
      setupFromNudge: true
    });
  },
  [TwoFactorAuthActionTypes.SELECT_2FA_SETUP_NUDGE](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.merge({
      show2FANude: false,
      setupStepIndex: indexOfStep(TwoFactorAuthSetupSteps.CHOOSE_METHOD),
      precedence: action.payload.precedence
    });
  },
  [TwoFactorAuthActionTypes.SKIP_2FA_SETUP_NUDGE](state) {
    return state.merge({
      show2FANude: false
    });
  },
  [TwoFactorAuthActionTypes.FETCHED_2FA_STATUS_SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.set('persistedStatus', action.payload.status);
  },
  [TwoFactorAuthActionTypes.USER_LOGIN_REQUIRED_FOR_2FA](state) {
    return state.set('requiresUserToLogin', true);
  },
  [TwoFactorAuthActionTypes.GENERATED_2FA_BACKUP_SUCCESS](state, action) {
    return state.setIn(['persistedStatus', 'backupCodesResponse'], fromJS(action.payload)).setIn(['persistedStatus', 'unusedBackupCodes'], 10).set('backupCodesLoading', false);
  },
  [TwoFactorAuthActionTypes.GENERATED_2FA_BACKUP_REQUEST](state) {
    return state.set('backupCodesLoading', true);
  },
  [TwoFactorAuthActionTypes.CLICKED_SETUP_2FA_BACKUP](state) {
    return state.set('backupModalVisible', true);
  },
  [TwoFactorAuthActionTypes.CLOSED_SETUP_2FA_BACKUP](state) {
    return state.set('backupModalVisible', false);
  },
  [TwoFactorAuthActionTypes.CLICKED_SETUP_2FA](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.merge({
      setupStepIndex: indexOfStep(TwoFactorAuthSetupSteps.CHOOSE_METHOD),
      precedence: action.payload.precedence,
      method: action.payload.stagedMethod,
      setupFromNudge: false
    });
  },
  [TwoFactorAuthActionTypes.STARTED_SETUP_2FA_FOR_LOGIN](state, action) {
    return state.merge({
      redirectUrl: action.payload && action.payload.redirectUrl !== undefined ? action.payload.redirectUrl : undefined,
      setupForLogin: true,
      setupStepIndex: indexOfStep(TwoFactorAuthSetupSteps.CHOOSE_METHOD),
      precedence: TwoFactorAuthPrecedenceTypes.PRIMARY
    });
  },
  [TwoFactorAuthActionTypes.SELECTED_2FA_METHOD](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.set('method', action.payload.method);
  },
  [TwoFactorAuthActionTypes.CONFIRMED_2FA_METHOD](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.mergeDeep({
      setupStepIndex: getConfirmMethodStep(action.payload.method, state.setupStepIndex),
      method: action.payload.method
    });
  },
  [TwoFactorAuthActionTypes.COMPLETED_GA_REGISTRATION](state) {
    return state.set('setupStepIndex', indexOfStep(TwoFactorAuthSetupSteps.VERIFY_GOOGLE_AUTHENTICATOR));
  },
  [TwoFactorAuthActionTypes.COMPLETED_HUBSPOT_APP_REGISTRATION](state) {
    return state.merge({
      setupStepIndex: indexOfStep(TwoFactorAuthSetupSteps.BACKUP_CODES),
      precedence: state.precedence === TwoFactorAuthPrecedenceTypes.PRIMARY ? TwoFactorAuthPrecedenceTypes.SECONDARY : TwoFactorAuthPrecedenceTypes.PRIMARY
    });
  },
  [TwoFactorAuthActionTypes.CONFIRMED_SMS_NUMBER](state) {
    return state.merge({
      verificationCodeAttempt: '',
      verificationCodeFailure: false,
      method: TwoFactorAuthMethods.SMS
    });
  },
  [TwoFactorAuthActionTypes.CONFIRMED_2FA_METHOD_SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    const {
      response
    } = action.payload;
    return state.mergeDeep({
      setupStepIndex: state.method === TwoFactorAuthMethods.SMS ? indexOfStep(TwoFactorAuthSetupSteps.VERIFY_SMS) : indexOfStep(TwoFactorAuthSetupSteps.REGISTER_HUBSPOT_WITH_GA),
      persistedStatus: {
        [state.precedence.toLowerCase()]: response.config
      },
      qrCode: response.qrInfo,
      isErrorSendingSMS: false
    });
  },
  [TwoFactorAuthActionTypes.CONFIRMED_2FA_METHOD_FAILURE](state) {
    if (state.method === TwoFactorAuthMethods.SMS) {
      return state.set('isErrorSendingSMS', true);
    }
    return state;
  },
  [TwoFactorAuthActionTypes.CONFIRMED_VERIFICATION_CODE_SUCCESS](state, action) {
    let nextStep = TwoFactorAuthSetupSteps.BACKUP_CODES;
    if (state.printedOrSavedBackupCodes) {
      nextStep = TwoFactorAuthSetupSteps.VERIFICATION_SUCCESSFUL;
    }
    if (!action.payload) {
      return state;
    }
    const persistedStatus = state.get('persistedStatus');
    const precedence = state.precedence.toLowerCase();
    return state.merge({
      persistedStatus: persistedStatus.set(precedence, action.payload.config),
      setupStepIndex: indexOfStep(nextStep),
      precedence: state.precedence === TwoFactorAuthPrecedenceTypes.PRIMARY ? TwoFactorAuthPrecedenceTypes.SECONDARY : TwoFactorAuthPrecedenceTypes.PRIMARY,
      verificationCodeAttempt: ''
    });
  },
  [TwoFactorAuthActionTypes.COMPLETED_BACKUP_CODES](state) {
    return state.set('setupStepIndex', indexOfStep(TwoFactorAuthSetupSteps.VERIFICATION_SUCCESSFUL));
  },
  [TwoFactorAuthActionTypes.CONFIRMED_VERIFICATION_CODE_FAILURE](state) {
    return state.merge({
      verificationCodeFailure: true
    });
  },
  [TwoFactorAuthActionTypes.CHANGED_VERIFICATION_CODE_ATTEMPT](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.merge({
      verificationCodeAttempt: action.payload.codeAttempt,
      verificationCodeFailure: false
    });
  },
  [combineActions(TwoFactorAuthActionTypes.COMPLETED_2FA_SETUP, TwoFactorAuthActionTypes.CANCELLED_2FA_SETUP)](state) {
    if (state.setupForLogin) {
      return state;
    }
    return state.merge({
      setupStepIndex: UNINITIALIZED_INDEX,
      method: TwoFactorAuthMethods.GOOGLE_AUTHENTICATOR,
      precedence: TwoFactorAuthPrecedenceTypes.PRIMARY,
      qrCode: null,
      stagedSMSNumber: '',
      isErrorSendingSMS: undefined,
      verificationCodeAttempt: '',
      verificationCodeFailure: false,
      printedOrSavedBackupCodes: false,
      setupForLogin: false,
      setupForLoginAccountInfo: undefined
    });
  },
  [TwoFactorAuthActionTypes.CONFIRMED_VALIDATION_REQUEST](state) {
    return state.merge({
      stagedSMSNumber: '',
      isErrorSendingSMS: undefined
    });
  },
  [TwoFactorAuthActionTypes.CONFIRMED_VALIDATION_SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    const {
      response,
      phoneNumber
    } = action.payload;
    if (response.isValid && response.geoPermission !== TwoFactorAuthSMSErrors.NOT_ALLOWED) {
      return state.set('stagedSMSNumber', phoneNumber);
    }
    return state;
  },
  [TwoFactorAuthActionTypes.CONFIRMED_VALIDATION_FAILURE](state, action) {
    if (!action.payload) {
      return state;
    }
    const {
      phoneNumber
    } = action.payload;
    return state.merge({
      stagedSMSNumber: phoneNumber,
      isErrorSendingSMS: undefined
    });
  },
  [TwoFactorAuthActionTypes.PRINTED_OR_SAVED_BACKUP_CODES](state) {
    return state.set('printedOrSavedBackupCodes', true);
  },
  [TwoFactorAuthActionTypes.TURNED_OFF_2FA_SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.merge({
      persistedStatus: action.payload.status,
      isHubSpotAppSet: false
    });
  },
  [TwoFactorAuthActionTypes.FETCHED_SETUP_PORTAL_2FA_STATUS_SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.merge({
      setupForLogin: true,
      setupForLoginAccountInfo: fromJS(action.payload.status)
    });
  },
  [TwoFactorAuthActionTypes.FETCHED_SETUP_PORTAL_2FA_STATUS_FAILURE](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.merge({
      setupForLogin: true,
      setupForLoginAccountInfo: fromJS({
        failed: true,
        portalId: action.payload.portalId
      })
    });
  },
  [TwoFactorAuthActionTypes.REDIRECT_TO_SECONDARY_2FA_SETUP](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.merge({
      setupStepIndex: indexOfStep(TwoFactorAuthSetupSteps.CHOOSE_METHOD),
      precedence: TwoFactorAuthPrecedenceTypes.SECONDARY,
      method: action.payload.stagedMethod,
      qrCode: null,
      stagedSMSNumber: '',
      isErrorSendingSMS: undefined,
      verificationCodeAttempt: '',
      verificationCodeFailure: false
    });
  },
  [TwoFactorAuthActionTypes.HUBSPOT_APP_STATUS_SUCCESS](state, action) {
    return state.set('isHubSpotAppSet', action.payload === 'CONFIRMED');
  },
  [TwoFactorAuthActionTypes.FETCHED_HUBSPOT_APP_VERSION_SUCCESS](state) {
    return state.set('hsMobileAppVersionStatus', RequestStatusTypes.SUCCEEDED);
  },
  [TwoFactorAuthActionTypes.FETCHED_HUBSPOT_APP_VERSION_FAILURE](state) {
    return state.set('hsMobileAppVersionStatus', RequestStatusTypes.FAILED);
  },
  [TwoFactorAuthActionTypes.FETCHED_2FA_STATUS_REQUEST](state) {
    return state.set('backupCodesLoading', true);
  },
  [TwoFactorAuthActionTypes.FETCHED_BACKUP_CODES_SUCCESS](state, action) {
    return state.setIn(['persistedStatus', 'backupCodesResponse'], fromJS(action.payload)).set('backupCodesLoading', false);
  }
}, initialState);